import type { TextField } from "@payloadcms/plugin-form-builder/types";
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from "react-hook-form";

import { Input } from "@onclicks/sharedcomponents/ui/Input";
import React from "react";

import { FieldError } from "./FieldError";
import { FieldLabel } from "./FieldLabel";
import { fieldClassName } from "./fieldStyles";

export const Text: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>;
    placeholder?: string;
    register: UseFormRegister<FieldValues>;
  }
> = ({ name, defaultValue, errors, label, placeholder, register, required }) => {
  return (
    <div className="flex flex-col gap-2">
      <FieldLabel htmlFor={name} label={label} required={required} />
      <Input
        defaultValue={defaultValue}
        id={name}
        type="text"
        placeholder={placeholder}
        aria-invalid={!!errors[name]}
        className={fieldClassName}
        {...register(name, { required })}
      />
      {errors[name] && <FieldError name={name} />}
    </div>
  );
};
